export function hasNullOrUndefined (obj: object | null | undefined): boolean {
  if (!obj) return false

  return Object.values(obj).some(value => value == null)
}
